import React from 'react';
import { Icon, Button, Popup } from 'semantic-ui-react';

import { VIEW } from '../../models/environments-sc/advanced/ScEnvView';

const iconStyle = { lineHeight: 1, height: '1em', width: '1em', fontSize: '1em', margin: 0 };

// expected props
// - view, current view mode
// - isAdmin, as boolean
// - compactMode, as boolean
// - onViewToggle
// - onCompactToggle
export default function EnvsHeader({
  view = VIEW.NORMAL,
  isAdmin = false,
  compactMode = false,
  onViewToggle,
  onCompactToggle,
}) {
  const isAdminView = view === VIEW.ADVANCED;
  const isFullView = !isAdminView && !compactMode;
  const isCompactView = !isAdminView && compactMode;

  return (
    <Button.Group size="small" className="workspace-view-toggle">
      <Popup
        trigger={
          <Button
            icon
            basic={!isFullView}
            color="blue"
            onClick={isFullView ? undefined : () => { if (isAdminView) onViewToggle(); if (compactMode) onCompactToggle(); }}
            className="workspace-header-btn"
          >
            <Icon name="th list" style={iconStyle} />
          </Button>
        }
        content="List View"
        position="top center"
        mouseEnterDelay={500}
        inverted
      />
      <Popup
        trigger={
          <Button
            icon
            basic={!isCompactView}
            color="blue"
            onClick={isCompactView ? undefined : () => { if (isAdminView) onViewToggle(); if (!compactMode) onCompactToggle(); }}
            className="workspace-header-btn"
          >
            <Icon name="th large" style={iconStyle} />
          </Button>
        }
        content="Compact Grid"
        position="top center"
        mouseEnterDelay={500}
        inverted
      />
      {isAdmin && (
        <Popup
          trigger={
            <Button
              icon
              basic={!isAdminView}
              color="blue"
              onClick={isAdminView ? undefined : () => { if (!isAdminView) onViewToggle(); }}
              className="workspace-header-btn"
            >
              <Icon name="shield" style={iconStyle} />
            </Button>
          }
          content="Admin View"
          position="top center"
          mouseEnterDelay={500}
          inverted
        />
      )}
    </Button.Group>
  );
}
